import { Component, signal, Injector } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SeoService } from './core/services/seo.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App  {
  protected readonly title = signal('referio');
  constructor(private seo : SeoService, private injector: Injector) {
    this.seo.init();
  }
}
